import pageLoad from './pageLoad'
import customEvent from './customEvent'

import { ENV } from 'gatsby-env-variables'

let scripts = []

const gaTags = {
  rvStage: 'G-8HNRL15TYC',
  recoveryProd: 'UA-45367306-5',
}

const optimizeTags = {
  rvStage: 'OPT-PMD2PS8',
  recoveryProd: 'OPT-MRNMXPX',
}

const gaTag = ENV === 'prod' ? gaTags.recoveryProd : gaTags.rvStage

const optimizeTag =
  ENV === 'prod' ? optimizeTags.recoveryProd : optimizeTags.rvStage

scripts = [
  ...scripts,
  <script
    key="GAScript"
    src={`https://www.googletagmanager.com/gtag/js?id=${gaTag}`}
    async={true}
  />,
  <script
    key="optimizeScript"
    src={`https://www.googleoptimize.com/optimize.js?id=${optimizeTag}`}
    async={true}
  />,
  <script
    key="GAdsScript"
    src="https://www.googletagmanager.com/gtag/js?id=AW-316483997"
    async={true}
  />,
  <script
    key="GAdsScriptDataLayerContent"
    dangerouslySetInnerHTML={{
      __html: `window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-316483997');
        gtag('config', '${gaTag}', { 'optimize_id': '${optimizeTag}'});`,
    }}
    async={true}
  />,
]

if (ENV === 'prod') {
  scripts = [
    ...scripts,
    <script // GA4 novo da RV visando migração futura
      key="GA4Script"
      src="https://www.googletagmanager.com/gtag/js?id=G-3VDXGSTV7S"
      async={true}
    />,
    <script // UA que era utilizada no segment
      key="UAConversionScript"
      src="https://www.googletagmanager.com/gtag/js?id=UA-204852905-1"
      async={true}
    />,
    <script
      key="newGAConfigScript"
      dangerouslySetInnerHTML={{
        __html: `window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-3VDXGSTV7S');
          gtag('config', 'UA-204852905-1');`,
      }}
      async={true}
    />,
  ]
}

export default {
  pageLoad,
  customEvent,
  scripts,
}
